// import { useCallback, useState } from "react";

// /**
//  * participantId -> deviceId
//  */
// export type CameraAssignments = Record<string, string>;

// interface UseCameraAllocatorArgs {
//   participantIds: string[];
//   initialDeviceIds: string[];
// }

// export const useCameraAllocator = ({
//   participantIds,
//   initialDeviceIds,
// }: UseCameraAllocatorArgs) => {
//   const [cameraAssignments, setCameraAssignments] = useState<CameraAssignments>(
//     () => {
//       const map: CameraAssignments = {};
//       participantIds.forEach((pid, index) => {
//         if (initialDeviceIds[index]) {
//           map[pid] = initialDeviceIds[index];
//         }
//       });
//       return map;
//     }
//   );

//   /**
//    * Swap cameras safely so no two participants
//    * ever share the same device
//    */
//   const assignCamera = useCallback(
//     (participantId: string, newDeviceId: string) => {
//       setCameraAssignments((prev) => {
//         const updated = { ...prev };

//         const currentDevice = prev[participantId];

//         // Find who currently owns the new device
//         const previousOwner = Object.keys(prev).find(
//           (pid) => prev[pid] === newDeviceId
//         );

//         // Swap if needed
//         if (previousOwner && currentDevice) {
//           updated[previousOwner] = currentDevice;
//         }

//         updated[participantId] = newDeviceId;

//         return updated;
//       });
//     },
//     []
//   );

//   return {
//     cameraAssignments,
//     assignCamera,
//   };
// };

// above code automatically updates the camera assignments

// this code manually updates the camera assignments

import { useCallback, useState } from "react";

export type CameraAssignments = Record<string, string>;

interface UseCameraAllocatorArgs {
  participantIds: string[];
  initialDeviceIds: string[];
}

export const useCameraAllocator = ({
  participantIds,
  initialDeviceIds,
}: UseCameraAllocatorArgs) => {
  const [cameraAssignments, setCameraAssignments] = useState<CameraAssignments>(
    () => {
      const map: CameraAssignments = {};
      participantIds.forEach((pid, index) => {
        if (initialDeviceIds[index]) {
          map[pid] = initialDeviceIds[index];
        }
      });
      return map;
    }
  );

  /**
   * 🔥 NO SWAP, NO SIDE EFFECTS
   * Only update the selected participant
   */
  const assignCamera = useCallback(
    (participantId: string, deviceId: string) => {
      setCameraAssignments((prev) => ({
        ...prev,
        [participantId]: deviceId,
      }));
    },
    []
  );

  return {
    cameraAssignments,
    assignCamera,
  };
};
